import axios from "axios";

export function isNameValid(string) {
  if (string.length < 2) {
    return false;
  }

  let re = /^[a-zA-Z0-9-' ]+$/;
  return re.test(string);
}

export function isEmailValid(string) {
  /* eslint-disable */
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  /* eslint-enable */
  return re.test(string);
}

export function submitEmail(emailAddress, callback) {
  const submissionString = `https://thedangercrew.us13.list-manage.com/subscribe/post-json?u=467755aba42db48795fa86c95&id=b40db07f16&c=?&EMAIL=${emailAddress}`;

  const axiosInstance = axios.create({
    withCredentials: true
  });

  axiosInstance
    .get(submissionString)
    .then(function(response) {
      callback();
    })
    .catch(function(error) {
      //Mailchimp throws weird cross domain errors, but the submission goes through anyway.
      //Just handle the success here...
      callback();
    });
}



// WEBPACK FOOTER //
// ./src/battle-optin/optin-utilities.js